export default __webpack_public_path__ + "static/summer_containers58-a712a2d2d76d1d8323868575d5dec287.webp";